import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootSelect: {
    '& .MuiFormLabel-root': {
      color: theme.palette.grey9,
      ...theme.rccl.labelMicro,
      '&.Mui-error': {
        '& + .MuiInputBase-root .MuiSelect-root': {
          border: `1px solid ${theme.palette.critical}`,
        },
      },
    },
    '& .MuiInputBase-root': {
      background: theme.palette.grey4,
      border: `1px solid ${theme.palette.grey4}`,
      height: 50,
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        marginBottom: '5px',
      },
      '&.Mui-focused': {
        border: `1px solid ${theme.palette.blue2}`,
      },
      '& > svg': {
        marginRight: theme.typography.pxToRem(5),
      },
    },
    '& .MuiFormLabel-filled + .MuiInputBase-root .MuiSelect-root': {
      color: theme.palette.grey1,
    },
    '& .MuiSelect-select': {
      color: theme.palette.grey8,
      ...{
        padding: `0 0 0 ${theme.typography.pxToRem(10)}`,
        [theme.breakpoints.down('xl')]: {
          '&.MuiSelect-selectMenu': {
            lineHeight: theme.typography.pxToRem(38),
          },
        },
      },
    },

    '& + .MuiFormHelperText-root': {
      color: theme.palette.grey6,
      fontSize: theme.typography.pxToRem(10),
    },
    '& + .MuiFormHelperText-root.Mui-error': {
      color: theme.palette.critical,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
    },
    '& .MuiSelect-icon': {
      fill: theme.palette.blue2,
      height: '24px',
      width: '24px',
    },
    [theme.breakpoints.down('xs')]: {
      '& + .MuiFormHelperText-root': {
        display: 'none',
        '&.Mui-error': {
          display: 'block',
        },
      },
    },
  },

  item: {
    color: theme.palette.grey2,
    letterSpacing: '0',
    textTransform: 'none',
    transition: 'color .5s',
    '&:hover': {
      background: theme.palette.blue2,
      color: theme.palette.grey4,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.blue1,
      color: 'white',
      opacity: '1',
    },
  },
  itemTitle: {
    backgroundColor: `${theme.palette.blue2} !important`,
    color: `${theme.palette.grey4} !important`,
    fontSize: theme.typography.pxToRem(16),
    letterSpacing: '0',
    opacity: '1 !important',
  },
  labelWithTooltipSelect: {
    marginRight: theme.typography.pxToRem(8),
  },
  tooltipLabel: {
    '& > div': {
      display: 'inline-block',
    },
  },
  tooltipContent: {
    width: '93%',
    fontSize: '14px',
    lineHeight: '150%',
  },
}));

export default useStyles;
